<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g :filter="`url(#${componentId}_filter0_i_7061_400)`">
      <path
        d="M17.2132 7.19489C17.2132 6.0642 16.2923 5.13309 15.1723 5.28816C11.9798 5.73017 8.99651 7.20084 6.69154 9.50581C3.90102 12.2963 2.33331 16.0811 2.33331 20.0275C2.33331 23.9739 3.90101 27.7587 6.69154 30.5492C8.99651 32.8542 11.9798 34.3248 15.1723 34.7669C16.2923 34.9219 17.2132 33.9908 17.2132 32.8601C17.2132 31.7294 16.2885 30.8325 15.1781 30.6191C13.0749 30.215 11.1231 29.1901 9.58688 27.6539C7.56424 25.6312 6.42794 22.8879 6.42794 20.0275C6.42794 17.1671 7.56424 14.4238 9.58688 12.4011C11.1231 10.865 13.0749 9.84005 15.1781 9.43591C16.2885 9.22254 17.2132 8.32559 17.2132 7.19489Z"
        :fill="`url(#${componentId}_paint0_linear_7061_400)`"
      />
      <path
        d="M17.2132 7.19489C17.2132 6.0642 16.2923 5.13309 15.1723 5.28816C11.9798 5.73017 8.99651 7.20084 6.69154 9.50581C3.90102 12.2963 2.33331 16.0811 2.33331 20.0275C2.33331 23.9739 3.90101 27.7587 6.69154 30.5492C8.99651 32.8542 11.9798 34.3248 15.1723 34.7669C16.2923 34.9219 17.2132 33.9908 17.2132 32.8601C17.2132 31.7294 16.2885 30.8325 15.1781 30.6191C13.0749 30.215 11.1231 29.1901 9.58688 27.6539C7.56424 25.6312 6.42794 22.8879 6.42794 20.0275C6.42794 17.1671 7.56424 14.4238 9.58688 12.4011C11.1231 10.865 13.0749 9.84005 15.1781 9.43591C16.2885 9.22254 17.2132 8.32559 17.2132 7.19489Z"
        :fill="`url(#${componentId}_paint1_linear_7061_400)`"
      />
    </g>
    <g filter="`url(#${componentId}_filter1_i_7061_400)`">
      <path
        d="M24.3827 32.8602C24.3827 33.9909 25.3037 34.922 26.4237 34.7669C29.6161 34.3249 32.5994 32.8542 34.9044 30.5492C37.6949 27.7587 39.2626 23.9739 39.2626 20.0275C39.2626 16.0811 37.6949 12.2964 34.9044 9.50585C32.5994 7.20088 29.6161 5.73022 26.4237 5.2882C25.3037 5.13313 24.3827 6.06424 24.3827 7.19494C24.3827 8.32563 25.3074 9.22258 26.4178 9.43595C28.521 9.84009 30.4729 10.865 32.0091 12.4012C34.0317 14.4238 35.168 17.1671 35.168 20.0275C35.168 22.888 34.0317 25.6313 32.0091 27.6539C30.4729 29.1901 28.521 30.215 26.4178 30.6191C25.3074 30.8325 24.3827 31.7295 24.3827 32.8602Z"
        :fill="`url(#${componentId}_paint2_linear_7061_400)`"
      />
      <path
        d="M24.3827 32.8602C24.3827 33.9909 25.3037 34.922 26.4237 34.7669C29.6161 34.3249 32.5994 32.8542 34.9044 30.5492C37.6949 27.7587 39.2626 23.9739 39.2626 20.0275C39.2626 16.0811 37.6949 12.2964 34.9044 9.50585C32.5994 7.20088 29.6161 5.73022 26.4237 5.2882C25.3037 5.13313 24.3827 6.06424 24.3827 7.19494C24.3827 8.32563 25.3074 9.22258 26.4178 9.43595C28.521 9.84009 30.4729 10.865 32.0091 12.4012C34.0317 14.4238 35.168 17.1671 35.168 20.0275C35.168 22.888 34.0317 25.6313 32.0091 27.6539C30.4729 29.1901 28.521 30.215 26.4178 30.6191C25.3074 30.8325 24.3827 31.7295 24.3827 32.8602Z"
        :fill="`url(#${componentId}_paint3_linear_7061_400)`"
      />
    </g>
    <foreignObject
      x="6.80328"
      y="-5.05994"
      width="18.8691"
      height="24.7964"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(2.59px); clip-path: url(#${componentId}_bgblur_0_7061_400_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <path
      data-figma-bg-blur-radius="5.18384"
      d="M12.439 2.75796C11.8365 2.15546 11.8365 1.17785 12.439 0.575343C13.0414 -0.02662 14.0176 -0.02662 14.62 0.575343L19.856 5.81135C20.6993 6.65486 20.6994 8.02291 19.856 8.86636L14.62 14.1007C14.0175 14.7032 13.0415 14.7032 12.439 14.1007C11.8365 13.4982 11.8365 12.5222 12.439 11.9197L17.0191 7.33967L12.439 2.75796Z"
      :fill="`url(#${componentId}_paint4_linear_7061_400)`"
      fill-opacity="0.3"
    />
    <foreignObject
      x="15.9235"
      y="20.3186"
      width="18.8691"
      height="24.7964"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(2.59px); clip-path: url(#${componentId}_bgblur_1_7061_400_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <path
      data-figma-bg-blur-radius="5.18384"
      d="M29.1569 37.2971C29.7594 37.8996 29.7594 38.8772 29.1569 39.4797C28.5545 40.0817 27.5783 40.0817 26.9759 39.4797L21.7399 34.2437C20.8966 33.4002 20.8964 32.0321 21.7399 31.1887L26.9759 25.9543C27.5784 25.3518 28.5544 25.3518 29.1569 25.9543C29.7594 26.5568 29.7594 27.5328 29.1569 28.1353L24.5768 32.7154L29.1569 37.2971Z"
      :fill="`url(#${componentId}_paint5_linear_7061_400)`"
      fill-opacity="0.3"
    />
    <defs>
      <filter
        :id="`${componentId}_filter0_i_7061_400`"
        x="2.33331"
        y="5.27124"
        width="15.9908"
        height="29.5126"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="1.11082" />
        <feGaussianBlur stdDeviation="0.740548" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_7061_400" />
      </filter>
      <filter
        :id="`${componentId}_filter1_i_7061_400`"
        x="24.3827"
        y="5.27124"
        width="15.9908"
        height="29.5126"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="1.11082" />
        <feGaussianBlur stdDeviation="0.740548" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_7061_400" />
      </filter>
      <clipPath :id="`${componentId}_bgblur_0_7061_400_clip_path`" transform="translate(-6.80328 5.05994)">
        <path
          d="M12.439 2.75796C11.8365 2.15546 11.8365 1.17785 12.439 0.575343C13.0414 -0.02662 14.0176 -0.02662 14.62 0.575343L19.856 5.81135C20.6993 6.65486 20.6994 8.02291 19.856 8.86636L14.62 14.1007C14.0175 14.7032 13.0415 14.7032 12.439 14.1007C11.8365 13.4982 11.8365 12.5222 12.439 11.9197L17.0191 7.33967L12.439 2.75796Z"
        />
      </clipPath>
      <clipPath :id="`${componentId}_bgblur_1_7061_400_clip_path`" transform="translate(-15.9235 -20.3186)">
        <path
          d="M29.1569 37.2971C29.7594 37.8996 29.7594 38.8772 29.1569 39.4797C28.5545 40.0817 27.5783 40.0817 26.9759 39.4797L21.7399 34.2437C20.8966 33.4002 20.8964 32.0321 21.7399 31.1887L26.9759 25.9543C27.5784 25.3518 28.5544 25.3518 29.1569 25.9543C29.7594 26.5568 29.7594 27.5328 29.1569 28.1353L24.5768 32.7154L29.1569 37.2971Z"
        />
      </clipPath>
      <linearGradient
        :id="`${componentId}_paint0_linear_7061_400`"
        x1="17.2132"
        y1="5.14758"
        x2="32.0932"
        y2="48.3106"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F4A2C0" />
        <stop offset="1" stop-color="#E468C9" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint1_linear_7061_400`"
        x1="32.7695"
        y1="35.5115"
        x2="13.5587"
        y2="-5.56914"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4646FB" />
        <stop offset="0.5" stop-color="#BE4DFF" />
        <stop offset="1" stop-color="#BC9AFF" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint2_linear_7061_400`"
        x1="24.3827"
        y1="34.9075"
        x2="9.50278"
        y2="-8.25553"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F4A2C0" />
        <stop offset="1" stop-color="#E468C9" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint3_linear_7061_400`"
        x1="8.82642"
        y1="4.54354"
        x2="28.0372"
        y2="45.6242"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4646FB" />
        <stop offset="0.5" stop-color="#BE4DFF" />
        <stop offset="1" stop-color="#BC9AFF" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint4_linear_7061_400`"
        x1="21.2614"
        y1="-0.204056"
        x2="7.19104"
        y2="3.94107"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4646FB" />
        <stop offset="0.5" stop-color="#BE4DFF" />
        <stop offset="1" stop-color="#BC9AFF" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint5_linear_7061_400`"
        x1="20.3345"
        y1="40.2591"
        x2="34.4048"
        y2="36.114"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4646FB" />
        <stop offset="0.5" stop-color="#BE4DFF" />
        <stop offset="1" stop-color="#BC9AFF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    componentId: {
      type: String,
      default: ''
    }
  }
}
</script>
